<div class="p-0">
  <div class="row toolbar align-items-center">
    <!-- Menu icon -->
    <div *ngIf="!showBackButton" (click)="openSideNav()" class="menu align-self-center p-0 mr-2">
      <span class="material-icons-outlined d-flex"> menu </span>
    </div>

    <div *ngIf="showBackButton" (click)="goBack()" class="menu col align-self-center px-1" style="max-width: 45px;">
      <!-- <span class="material-icons-outlined d-flex"> arrow_back </span> -->
      <i class="bi bi-chevron-left"></i>
    </div>

    <!-- Toolbar name -->
    <div class="col toolbarLabel pl-0">
      <div *ngIf="toolbarDetails?.isShopFiltered !== true" class="d-flex flex-column align-items-start justify-content-center">
        <div *ngIf="toolbarDetails?.isShopService !== true">
          <span (click)="gotoPage('/servicenear/dashboard')" style="font-weight: 700;">{{ toolbarDetails.title }}</span>
        </div>
        <div *ngIf="toolbarDetails?.isShopService === true" class="d-flex align-items-center justify-content-between w-100">
          <span (click)="gotoPage('/servicenear/dashboard')" style="font-weight: 700;">{{ toolbarDetails.title }}</span>
          <div class="d-flex align-items-center" style="font-size: 15px;">
            <div><i style="font-size:20px;" class="bi bi-shop ml-0 mr-2"></i></div>
            <div class="ellipsis" style="max-width: 150px;">{{toolbarDetails?.ShopName}}</div>
            <div *ngIf="toolbarDetails?.isCall" class="ml-2 call-btn" (click)="callNumber(toolbarDetails?.phoneNo)" ><i class="bi bi-telephone-fill p-0 m-0" style="font-size: 16px;" ></i></div>
          </div>
        </div>
      </div>
      <div *ngIf="toolbarDetails?.isShopFiltered === true"
        class=" d-flex flex-column align-items-start justify-content-center">
        <div> <span class="ellipsis" style="font-weight: 800;">{{ toolbarDetails.ShopName }}</span> </div>
        <span style="font-weight: 700; font-size: 14px; line-height: 1;">{{ toolbarDetails.title }}</span>
      </div>
    </div>

  </div>
</div>

<!--|||||||||||| SIDE MENU ||||||||||||-->
<div id="mySidenav" class="sidenav">

  <div class="row menu-top-section pb-2">
    <div class="d-flex flex-column ml-3" style="line-height: 1.42;">
      <div style="font-size: 22px; font-weight: 800;">servicenear<span style="color: #FE9000;">.in</span> </div>
      <div style="font-size: 8px; font-weight: 800;">{{configService.version}}</div>
    </div>
    <div style="width: 30%;">
      <div class="d-flex" style="width: 50px; height: 50px;">
        <div *ngIf="configService.sellerConfiguration?.SellerLogo; else storeIcon" class="shop-logo">
          <img [src]="configService.sellerConfiguration?.SellerLogo" onerror="this.src='/assets/images/ecomshop.png'">
        </div>

        <ng-template #storeIcon>
          <div class="sellerlogo">
            <img src="/assets/images/ecomshop.png" style="margin: 20%;width: 40px;">
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Plan section -->
  <div class="plan-banner p-2" style="line-height: 1.42;">
    <div class="d-flex flex-column justify-content-center align-items-center"
      style="font-size: 12px; font-weight: 600; color: #00BBA6; width: 25%;">
      <span>TRAIL</span><span>PLAN</span>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center"
      style="width: 25%; border-left:1px solid rgb(214, 214, 214);">
      <div style="font-size: 9px; color: #686868; font-weight: 600;">Jobs Balance</div>
      <div style="font-size: 14px; font-weight: 600; color:#00BBA6;">Unlimited</div>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center" style="width: 45%;">
      <div style="font-size: 10px; font-weight: 300; color:#686868;">{{this.adminDetails?.SellerName}}</div>
      <div style="font-size: 13px; font-weight: 600; color:#686868;">{{this.adminDetails?.Name}}</div>
    </div>
  </div>

  <!--  $$$$$$$$$$$$$$$$$$ FOR ADMIN $$$$$$$$$$$$$$$$$$  -->

  <div class="row menu-scroll">
    <ng-container *ngFor="let item of menuItemsList">
      <ng-container
        *ngIf="!item.hidden && !(item.label === 'Switch to OldUI' && privilegeService.getServicenearPrivilege('disableSwitchUI', false))">
        <div class="col-12 p-0 menuItemWrap" [class.disabled]="item.disabled">
          <div class="row">
            <div class="d-flex align-items-center">
              <img [src]="item.image" alt="{{ item.label }}" width="14" height="14" />
              <a *ngIf="item.label !== 'Logout' && item.path !== '/?activateoldui=true'" (click)="gotoPage(item.path)"
                class="menu-list">
                {{ item.label }}
              </a>
              <a *ngIf="item.path === '/?activateoldui=true'" (click)="routeToServicenear()" class="menu-list">
                {{ item.label }}
              </a>
              <a *ngIf="item.path === '/servicenear/logout'" (click)="logOutClicked()" class="menu-list">
                {{ item.label }}
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- whats new section -->
  <div class="whats-new-banner w-100 mt-3 p-1" style="position: absolute; bottom: 0; left: 0;">
    <div class="d-flex flex-column justify-content-center align-items-start ml-3"
      style="font-size: 10px; font-weight: 600;">
      <div>What's new <span style="color: #00BBA6;">?</span></div>
      <div>{{configService.version}}</div>
    </div>
    <div>
      <i class="bi bi-chevron-right" style="font-size: 10px;"></i>
    </div>
  </div>

</div>

<div id="myCloseContainer" (click)="closeSideNav()" class="close-container">
  <div class="d-flex justify-content-end p-1">
    <div class="close-container-btn d-flex justify-content-center align-content-center">
      <i class="material-icons d-flex">close</i>
    </div>
  </div>
</div>